var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDemo)?_c('v-alert',{staticClass:"demo-banner mb-0",attrs:{"type":"info","dense":"","text":""}},[_c('strong',[_vm._v(_vm._s(_vm.$t('demo_mode'))+":")]),_vm._v(" "+_vm._s(_vm.$t('demo_mode_notice'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }